export default __webpack_public_path__ + "static/media/credit_card.0fdd6da1.png";